export const IS_LIVE = process.env.REACT_APP_HIDE_FEATURES === "true";
